import { useSession } from 'next-auth/react';
import { createContext, useContext, useEffect } from 'react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

const TrackingContext = createContext(null);

export function useTracking() {
  return useContext(TrackingContext);
}

export function TrackingProvider({ children }) {
  const { data: session } = useSession();

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host:
          process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
        defaults: '2025-05-24',
        loaded: (ph) => {
          if (process.env.NODE_ENV === 'development') ph.debug();
        },
      });
    }
  }, []);

  useEffect(() => {
    if (!session?.user || !process.env.NEXT_PUBLIC_POSTHOG_KEY) {
      return;
    }
    const user = {
      id: session.user.id,
      email: session.user.email,
      nome: session.user.name,
    };
    posthog.identify(user.id, user);
  }, [session]);

  return (
    <PostHogProvider client={posthog}>
      <TrackingContext.Provider value={null}>{children}</TrackingContext.Provider>
    </PostHogProvider>
  );
}
